import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DispatchDeviceAddComponent } from './dispatch-device-add.component';

const routes: Routes = [
  {
    path: 'dispatch-device-add',
    component: DispatchDeviceAddComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DispatchDeviceAddRoutingModule {}
